import { FC } from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { InputWithFloatingLabel } from 'components/Form/InputWithFloatingLabel';
import classNames from 'classnames';

interface Props extends FieldProps<HTMLInputElement, FieldRenderProps<any>> {
  label?: string;
}

export const TextFieldWithFloatingLabel: FC<Props> = ({
  label,
  name,
  maxLength,
  ...fieldProps
}) => {
  return (
    <Field name={name} allowNull {...fieldProps}>
      {({ input, meta }) => (
        <InputWithFloatingLabel
          className={classNames({
            error: (meta.error || meta.submitError) && meta.touched,
            disabled: fieldProps.disabled,
          })}
          disabled={fieldProps.disabled}
          error={meta.touched && (meta.error || meta.submitError)}
          label={label}
          maxLength={maxLength}
          {...input}
        />
      )}
    </Field>
  );
};
